import { Spacing } from '@persona-id/design-tokens';
import { EyeOffIcon } from '@persona-id/design-tokens/icons';
import { FunctionComponent, ReactNode } from 'react';
import styled from 'styled-components';

import { Paragraph, Span } from 'design-system/components/Text';
import Tooltip from 'design-system/components/Tooltip';

interface PageUnavailbleProps {
  popoverText: string;
  children: ReactNode;
}

const Container = styled('div')`
  position: relative;
`;

const SkippedContainer = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.3);
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 400px;
  height: 100%;
  z-index: 1;
`;

const TooltipTriggerContainer = styled('div')`
  background: ${({ theme }) => theme.color.background.primary};
  border-radius: 1000px;
  padding: ${Spacing[2]} ${Spacing[3]};
  margin-top: ${Spacing[3]};
  cursor: pointer;

  svg {
    color: ${({ theme }) => theme.color.text.secondary};
  }

  span {
    margin-left: ${Spacing[2]};
    line-height: 0;
    font-size: ${({ theme }) => theme.text.paragraph.md.fontSize};
  }

  span,
  svg {
    vertical-align: middle;
  }
`;

export const PageUnavailable: FunctionComponent<PageUnavailbleProps> = ({
  popoverText,
  children,
}) => {
  return (
    <>
      <Container data-test='page-unavailable-screen'>
        <SkippedContainer>
          <Tooltip
            hideArrow
            side='top'
            trigger={
              <TooltipTriggerContainer>
                <EyeOffIcon width={13} height={13} />
                <Span color='secondary'>Skipped</Span>
              </TooltipTriggerContainer>
            }
          >
            <Paragraph color='primary' style={{ width: '350px' }}>
              {popoverText}
            </Paragraph>
          </Tooltip>
        </SkippedContainer>
        {children}
      </Container>
    </>
  );
};
